import React from 'react';
import PageTemplate from 'components/common/PageTemplate';
import JobInfo from 'view/jobInfo';

const JobManagePage = () => {
	return (
		<PageTemplate>
			<JobInfo />
		</PageTemplate>
	);
};

export default JobManagePage;

 